<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        width="24"
        height="24"
        fill="currentColor"
    >
        <rect x="7.25" y="9" width="1.5" height="11" rx="0.75" />
        <polygon points="8,3.5 12.5,9.5 3.5,9.5" />
        <rect x="15.25" y="4" width="1.5" height="11" rx="0.75" />
        <polygon points="16,20.5 11.5,14.5 20.5,14.5" />
    </svg>
</template>

<script>
export default { name: "SortIcon" };
</script>
